import { Component, ViewEncapsulation, Output, EventEmitter, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { Router } from '@angular/router';
import { RoutesTable } from '@toro/common/shared/resources/routes-table.model';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { SantanderSuitabilityService } from '@toro/common/shared/services/santander-suitability/santander-suitability-service';
import { ILoggedHomeAppState } from '@hub-workspace/apps/logged-home/src/app/shared/interfaces/logged-home-app-state.interface';
import { environment } from '@hub-workspace/apps/logged-home/src/environments/environment';

@Component({
    selector: 'home-logged-transfer',
    templateUrl: './home-logged-transfer.component.html',
    styleUrls: ['./home-logged-transfer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [],
})
export class HomeLoggedTransferComponent implements OnInit {
    public isNewBrand: boolean = environment.isNewBrand

    @Output() public openYoutubeEmmiter = new EventEmitter();

    public showInfosMobile: boolean;
    public textBtInfosMobile: string;
    public showIntendInvestAdviceText: boolean = false;
    public videoList = [
      {
          id: '395240540',
          title:  `Conheça a ${this.isNewBrand ? 'Santander Corretora' : 'Toro'}`,
          img: 'home/assets/images/congratulations/videos-thumbs/thumb-01.png',
          url: 'https://player.vimeo.com/video/395240540?color=47911e&title=0&byline=0&portrait=0'
      },
      {
          id: '395240862',
          title: 'O que é a Bolsa de Valores?',
          img: 'home/assets/images/congratulations/videos-thumbs/thumb-02.png',
          url: 'https://player.vimeo.com/video/395240862?color=47911e&title=0&byline=0&portrait=0'
      },
      {
          id: '395240800',
          title: 'O que são Fundos Imobiliários?',
          img: 'home/assets/images/congratulations/videos-thumbs/thumb-03.png',
          url: 'https://player.vimeo.com/video/395240800?color=47911e&title=0&byline=0&portrait=0'
      },
      {
          id: '395240765',
          title: 'Diversificação da carteira',
          img: 'home/assets/images/congratulations/videos-thumbs/thumb-04.png',
          url: 'https://player.vimeo.com/video/395240765?color=47911e&title=0&byline=0&portrait=0'
      },
      {
          id: '395240585',
          title: 'Onde investir',
          img: 'home/assets/images/congratulations/videos-thumbs/thumb-05.png',
          url: 'https://player.vimeo.com/video/395240585?color=47911e&title=0&byline=0&portrait=0'
      },
      {
          id: '395241371',
          title: 'Renda Fixa: o que é e como investir',
          img: 'home/assets/images/congratulations/videos-thumbs/thumb-06.png',
          url: 'https://player.vimeo.com/video/395241371?color=47911e&title=0&byline=0&portrait=0'
      }
    ]

    /* Observables */
    public authentication$: Observable<any>;

    constructor(
        public utilitiesService: UtilitiesService,
        private store: Store<AppState>,
        private router: Router,
        private santanderSuitabilityService: SantanderSuitabilityService,
    ) {
        this.authentication$ = this.store.select((state) => state.authentication);
     }

    public ngOnInit() {
        this.showInfosMobile = false;
        this.textBtInfosMobile = 'Ver mais';
        this.subscribeSuitabilityAnswers();
        this.sendPageLoadedWhenWalletReady();
    }

    private sendPageLoadedWhenWalletReady() {
        this.store
            .select((state: ILoggedHomeAppState) => state.customerWallet)
            .pipe(
                filter((customerWallet) => !!customerWallet && customerWallet.isLoaded),
                take(1),
            )
            .subscribe(() => {
                this.sendTracking(ActionEventsEnum.PAGE_LOADED, {
                    'Product Area Origin': 'Home',
                    'Status': 'Aberta',
                    'Step': 'Não se aplica',
                    'Scenario': this.santanderSuitabilityService.getClientSegment(),
                    'Time Responsável': 'Sky',
                });
            });
    }

    public sendTracking(event: string, breakdowns: Record<string, unknown>) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: { type: event, events: breakdowns },
        });
    }

    public toggleBankInformations() {
        const elem: any = document.querySelector('.list-bank-infos ul');
        if (this.showInfosMobile) {
            this.textBtInfosMobile = 'Ver mais';
            elem.style.height = '43px';

        } else {
            this.textBtInfosMobile = 'Ocultar';
            elem.style.height = '175px';
        }
        this.showInfosMobile = !this.showInfosMobile;
    }

    public redirectToBankData() {
        this.router.navigateByUrl(RoutesTable.hubUrls.routes.MyAccountBankData.uri);
    }

    public scrollInterationClickButtom() {
        const body = $('html, body');
        const scrollTopElement = $('#doubts-section')
            .offset().top;

        body.animate(
            { scrollTop: scrollTopElement },
            700,
        );
    }

    public openYoutubeDialog() {
        this.openYoutubeEmmiter.emit(true);
    }

    /**
     * Método que scrolla a página para a dobra selecionada
     * @param id anchor
     */
    public goTo(id: string) {
        const element = $(id);
        $('html, body')
            .animate({
                scrollTop: element.offset().top,
            }, 1200);
    }

    private subscribeSuitabilityAnswers() {
        this.store.select((state) => state.suitability.usersAnswers)
            .subscribe((answers) => {
                if (answers) {
                    const answerIntendInvestimentValue = answers.find((answer) => answer.questionID === 14);
                    if (!answerIntendInvestimentValue || Number(answerIntendInvestimentValue.answer) < 5000) {
                        this.showIntendInvestAdviceText = true;
                    }
                }
            });
    }
}
